// Work categories — drives the /work overview page.
// Add a new category here and a corresponding route in App.js to make it appear.

export const workCategories = [
  {
    id: 'ux',
    title: 'UX Design',
    desc: 'Twelve+ enterprise & consumer case studies across SPM, healthcare, food, transit and wellness.',
    path: '/ux-folio',
    cover: '/project/ux.png',
    count: '14 case studies',
  },
  {
    id: 'website',
    title: 'Website Design & Development',
    desc: '80+ websites delivered — e-learning, manufacturing, music, healthcare and travel.',
    path: '/website-folio',
    cover: '/project/website.png',
    count: '80+ projects',
  },
  {
    id: 'illustration',
    title: 'Illustration',
    desc: 'Hand-crafted and generative illustrations — texture, colour, and a bit of restraint.',
    path: '/illustration',
    cover: '/project/illustration.png',
    count: 'Side studio',
  },
  {
    id: 'digital-art',
    title: 'Digital Art',
    desc: 'A small latent gallery of generative pieces — prompt, iterate, curate, post.',
    path: '/ai-art',
    cover: '/project/digital.png',
    count: 'Latent gallery',
  },
];
